<template>
    <div class="table-container">
        <el-form :inline="true" size="small" :model="dataForm" @keyup.enter.native="getDataList()">
                <el-button size="small" type="primary" @click="addOrUpdateHandle()" icon="el-icon-plus">
                    新建根目录
                </el-button>
            <!-- </el-form-item> -->
        </el-form>
        <el-table :data="dataList" row-key="id" size="small" style="width: 100%;" :default-expand-all="true" :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
            <el-table-column
                    type="index"
                    width="50"
                    label="序号">
            </el-table-column>
            <el-table-column
                    prop="materialGroupCode"
                    header-align="left"
                    align="left"
                    label="物料分类编码">
            </el-table-column>
            <el-table-column
                    prop="materialGroupName"
                    header-align="left"
                    align="left"
                    label="物料分类名称">
            </el-table-column>
          <el-table-column
              prop="isLeaf"
              header-align="left"
              align="left"
              label="是否为叶节点"
              :formatter="formatIsLeaf"
          >
          </el-table-column>
            <!-- <el-table-column
                    prop="orgType"
                    header-align="left"
                    align="left"
                    label="物料分类类型"
                    :formatter="formatOrgType"
                    >
            </el-table-column> -->
            <!--<el-table-column prop="tenantName" header-align="left" align="left" min-width="100" label="租户">-->
            <!--</el-table-column>-->
            <el-table-column header-align="left" align="left" min-width="130" label="操作">
                <template slot-scope="scope">
                    <!-- <el-button type="text" size="small" @click="addChildHandle(null,scope.row.id,scope.row.orgName, scope.row.nodePath,scope.row.orgType)" icon="el-icon-circle-plus-outline"> -->
                        <el-button type="text" size="small" @click="addChildHandle(scope.row)" icon="el-icon-circle-plus-outline">
                        新建附属物料
                    </el-button>
                    <el-button type="text" size="small" @click="updateHandle(scope.row)" icon="el-icon-edit">
                        修改
                    </el-button>
                    <el-button type="text" size="small" @click="deleteHandle(scope.row.id)" icon="el-icon-delete">
                        删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 弹窗, 新增 / 修改 -->
        <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
        <add-child v-if="addChildVisible" ref="addChild" @refreshDataList="getDataList"></add-child>
        <!-- <update v-if="updateVisible" ref="update" @refreshDataList="getDataList"></update> -->
    </div>
</template>

<script>
    import {fetchOrgForTenant, fetchMtlForMainBody, deleteMtl} from '@/controller/mdata'
    import AddOrUpdate from './mtl-add-or-update.vue'
    import AddChild from './mtl-add-child.vue';
    // import Update from './org_update.vue'
    export default {
        data() {
            return {
                documentClientHeight: document.documentElement['clientHeight'] - 220,
                dataForm: {
                    materialGroupCode: '',
                    materialGroupName: '',
                
                },
                dataList: [],
                tenantList: [],
                pageIndex: 1,
                pageSize: 100000,
                totalPage: 0,
                dataListLoading: false,
                dataListSelections: [],
                addOrUpdateVisible: false,
                addChildVisible: false,
                updateVisible: false

            }
        },
        components: {
            AddChild,
            AddOrUpdate,
            // AddOrUpdateChild

        },
        activated() {
            this.getDataList()
        },
        methods: {
            // 新增子节点
            addChildHandle(row) {
              if(1===row.isLeaf){
               return this.$message({
                  message: '叶节点下不能再创建下一级分类',
                  type: 'warning'
                });
              }
                console.log("zijiedian")
                this.addChildVisible = true
                this.$nextTick(() => {
                    this.$refs.addChild.init(row)
                }) 
            },

    
              // 新增根目录
              addOrUpdateHandle(row) {
                console.log("rows",row)
                this.addOrUpdateVisible = true
                this.$nextTick(() => {
                    console.log("jjjjj",this.$refs.addOrUpdate)
                    this.$refs.addOrUpdate.init(row?row.id: null, 0, null, null, null)
                })
            },

            //修改
            updateHandle(row) {
                console.log("修改",row)
                this.addOrUpdateVisible = true
                this.$nextTick(() => {
                    this.$refs.addOrUpdate.init(row)
                })
            },



            // 获取数据列表
            getDataList() {
                this.dataListLoading = true
                
                // if(this.$store.state.user.userInfo.typeId === 2){
                //     fetchOrgForTenant(
                //         {
                //             'orgCode': this.dataForm.code,
                //             'orgName': this.dataForm.name
                //         }
                //     ).then(data => {
                //         if (data && data.code === '00') {
                //             this.dataList = data.body
                //             this.totalPage = data.body.total
                //         } else {
                //             this.dataList = []
                //             this.totalPage = 0
                //         }
                //         this.dataListLoading = false
                //     })
                // } else {
                    // TODO 查询条件
                    fetchMtlForMainBody(
                        {}, sessionStorage.getItem('mainBodyId')
                    ).then(data => {
                        if (data && data.code === '00') {
                            this.dataList = data.body
                            this.totalPage = data.body.total
                        } else {
                            this.dataList = []
                            this.totalPage = 0
                        }
                        this.dataListLoading = false
                    })
                // }
            },
            // 每页数
            sizeChangeHandle(val) {
                this.pageSize = val
                this.pageIndex = 1
                this.getDataList()
            },
            // 当前页
            currentChangeHandle(val) {
                this.pageIndex = val
                this.getDataList()
            },
            // 多选
            selectionChangeHandle(val) {
                this.dataListSelections = val
            },
          
            // 删除
            deleteHandle(id) {
                this.$confirm(`确定进行删除操作?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    console.log("真的删除了吗")
                    deleteMtl(
                        {}, id
                    ).then(data => {
                        if (data && data.code === '00') {
                            this.$message({
                                message: '操作成功',
                                type: 'success',
                                duration: 1500,
                                onClose: () => {
                                    this.getDataList()
                                }
                            })
                        } else {
                            this.$message.error(data.msg)
                        }
                    })
                })
            },

            //转换组织类型
            formatOrgType(row, column, value, index){
                const typeMap = {
                    'ROOT': '管理总部',
                    'DIV': '事业部',
                    'COM': '子公司',
                    'PUR': '采购组织',
                    'WORK': '工厂',
                    'DEP': '科室',
                    'OTHER': '其他'
                };
                return typeMap[value] || value;
            },
          //是否为叶节点
          formatIsLeaf(row, column, value, index){
            const typeMap = {
              1: '是',
              0: '否',
            };
            return typeMap[value] || value;
          }
        }
    }
</script>

<style>
    .table-container {
        height: 460px;
        overflow-y: auto;
    }
</style>
